/**
 * Vuex getters for the "subscribe" module.
 *
 * Thin state accessors exposing the following/followers lists and their
 * counts as-is.
 */
export default {
  getFollowing: (state) => state.following,
  getFollowers: (state) => state.followers,
  getFollowingCount: (state) => state.followingCount,
  getFollowersCount: (state) => state.followersCount,
};
